import { useCallback } from 'react';
import { create } from 'zustand';

import { axiosInstanceV3 } from '@mais-retorno-front/configs/axios-config';

interface IUseStore {
  data: any;
  loading: boolean;
  setLoading: (isLoading: boolean) => void;
  setData: (stats: any) => void;
}

const useStore = create<IUseStore>((set) => ({
  data: [],
  loading: true,
  setLoading: (isLoading: boolean) => set({ loading: isLoading }),
  setData: (data: any) => set({ data }),
}));

export const useSheetFundRelated = () => {
  const relatedFunds = useStore((state) => state.data);
  const loading = useStore((state) => state.loading);
  const setLoading = useStore((state) => state.setLoading);
  const setData = useStore((state) => state.setData);

  const getRelatedFunds = useCallback(
    async (fundSlug: string) => {
      setLoading(true);

      try {
        const { data } = await axiosInstanceV3.get(
          `/funds/related/${fundSlug}`
        );

        setData(data);
      } catch (error) {
        setData([]);
      }

      setLoading(false);
    },
    [setData, setLoading]
  );

  return {
    loadingRelatedFunds: loading,
    relatedFunds,
    getRelatedFunds,
  };
};
